import { FieldArray } from 'formik';
import React from 'react';
import OutlinedStadiumButton from '../../../../customComponents/button/OutlinedStadiumButton';
import StadiumButton from '../../../../customComponents/button/StadiumButton';
import BoreholeConstantRateNeighbouringFormField from '../../../../customComponents/form/boreholeConstantRate/BoreholeConstantRateNeighbouringFormField';

interface IBoreholeConstantRateEditDialogNeighbouringTabProps {
    isLoading : boolean;

    onNextClick ?: () => void;
    onBackClick ?: () => void;
}

interface IBoreholeConstantRateEditDialogNeighbouringTabState {}

export default class BoreholeConstantRateEditDialogNeighbouringTab extends React.PureComponent<IBoreholeConstantRateEditDialogNeighbouringTabProps, IBoreholeConstantRateEditDialogNeighbouringTabState> {
    constructor(props : IBoreholeConstantRateEditDialogNeighbouringTabProps) {
        super(props);
        this.state = {};
    }

    public readonly render = () => {
        const { onNextClick, onBackClick } = this.props;
        return (
            <div className='fdc flx1 ml15 mr15 mt15'>
                <FieldArray
                    name='neighbouringBoreholes'
                    render={(props) => <BoreholeConstantRateNeighbouringFormField {...props} />}
                />
                <div className='fdr jcfe mt15'>
                    <div className='mr15'>
                        <OutlinedStadiumButton onClick={onBackClick}>
                            Back
                        </OutlinedStadiumButton>
                    </div>
                    <div>
                        <StadiumButton onClick={onNextClick}>
                            Next
                        </StadiumButton>
                    </div>
                </div>
            </div>
        );
    };
}
